import { render, staticRenderFns } from "./MaterialDetectionPage.vue?vue&type=template&id=f120e566&"
import script from "./MaterialDetectionPage.vue?vue&type=script&lang=js&"
export * from "./MaterialDetectionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports